// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__e+m5o","modal":"denied_modal__mPjiC","bounce":"denied_bounce__8Icxy","overlay":"denied_overlay__P2guy","wrapper":"denied_wrapper__-MM5u"};